// @ts-nocheck
import { LOGINS_HISTORY_LIST_RECEIVED } from '../types';

const initialState = {
    list: [],
};

const loginsHistory = (state = initialState, action) => {
    const { payload } = action;
    switch (action.type) {
        case LOGINS_HISTORY_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        default: {
            return state;
        }
    }
};
export default loginsHistory;
